















import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import { Col, Row, Tag } from 'vant';
import { FaqInfo } from  "@/data/local/faq";

Vue.use(Col);
Vue.use(Row);
Vue.use(Tag);

@Component({})
export default class FaqItem extends Vue {
  @Prop(Object)
  private itemData: FaqInfo | null;

  created() {
    
  }

  mounted() {
    
  }

  get cat(): string {
    if (this.itemData.cat === 1) {
      return "公积金贷款";
    } else if (this.itemData.cat === 2) {
      return "公积金提取";
    } else if (this.itemData.cat === 3) {
      return "公积金缴存";
    } else {
      return "其他"
    }
  }

  @Emit("clickItem") 
  private onClickItem(): FaqInfo | null {
      return this.itemData
  }
}
